import {SceneInjectionChain} from "../gameobjects/SceneInjectionChain";
import {SceneInjectionCharacterReaction} from "../gameobjects/SceneInjectionCharacterReaction";
import {CharlesDickensCutouts} from "../layout/CharlesDickensCutouts";
import {
    CharlesDickensStoryLayout_scene1Start,
    CharlesDickensStoryLayout_scene2Imagination,
    CharlesDickensStoryLayout_scene3Location,
    CharlesDickensStoryLayout_scene4Chair,
    CharlesDickensStoryLayout_scene5Belt,
    CharlesDickensStoryLayout_scene6End,
} from "../layout/CharlesDickensStoryLayout";
import {BookId} from "./BookId";
import {CharacterType} from "./CharacterType";
import {CutoutData} from "./CutoutData";
import {StoryModel} from "./StoryModel";

export const StoryCharlesDickens: StoryModel<CharlesDickensSceneId, CharlesDickensSlotId> = {
    storyId: BookId.Dickens,
    storyIndex: 3,
    promptVO: "dic_yadina_st_{index}",
    optionVO: "dic_yadina_st_{index}",
    introVO: ["dic_brad_in_001", "dic_xavier_in_001", "dic_yadina_in_001"],
    outroVO: ["dic_brad_out_001", "dic_yadina_out_001", "dic_xavier_out_001"],
    outroImage: "dic-story-image",
    optionIcon: "dic-{option}-buttonimg",
    cutouts: new CutoutData(CharlesDickensCutouts),
    scenes: [
        {
            sceneId: "start",
            sfx: "sc_004_XR103A_007_Whomps Brad and Xavier Tumble",
            cc: "One day, Brad was laying down on his {option-start.}",
            voIndex: 1,
            options: [
                {optionId: "couch", cc: "Couch", voIndex: 2},
                {optionId: "beanbag", cc: "Bean Bag", voIndex: 3},
                {optionId: "blanket", cc: "Blanket", voIndex: 4},
                {optionId: "bed", cc: "Bed", voIndex: 5},
            ],
            layout: CharlesDickensStoryLayout_scene1Start,
        },
        {
            sceneId: "imagination",
            sfx: "sc_074_surprising",
            cc: "When suddenly, Brad imagined it was {option-imagination!}",
            voIndex: 6,
            options: [
                {optionId: "airplane", cc: "An Airplane", sfx: {sc_074_surprising: 0, sc_082_airplane: 1}, voIndex: 7},
                {optionId: "castle", cc: "A Castle", iconPosition: {x: 0, y: -40}, sfx: {"sc_074_surprising": 0, "sc_025_XR111B_014_Triumphant Intro": 1}, voIndex: 8},
                {optionId: "spaceship", cc: "A Spaceship", iconPosition: "center", sfx: {sc_074_surprising: 0, sc_083_spaceship: 1}, voIndex: 9},
                {optionId: "whale", cc: "A Whale", iconPosition: {x: 0, y: -50}, sfx: {"sc_074_surprising": 0, "sc_057_XR111B_003_Whale Noise": 1}, voIndex: 10},
            ],
            layout: CharlesDickensStoryLayout_scene2Imagination,
        },
        {
            sceneId: "location",
            sfx: "sc_069_XRMovie_689_Majestic Music",
            cc: "And, Brad imagined he was in {option-location!}",
            voIndex: 11,
            options: [
                {optionId: "sea", cc: "The Ocean", iconPosition: "center", voIndex: 12},
                {optionId: "space", cc: "Outerspace", iconPosition: "center", voIndex: 13},
                {optionId: "baseballfield", cc: "a Baseball Game", iconPosition: "center", voIndex: 14},
                {optionId: "clouds", cc: "The Clouds", voIndex: 15},
            ],
            layout: CharlesDickensStoryLayout_scene3Location,
        },
        {
            sceneId: "chair",
            cc: "Then, Brad imagined he saw {option-chair!}",
            voIndex: 16,
            options: [
                {optionId: "chickens", cc: "Chickens", sfx: "sc_056_XR113B_099_Flat Bass-y Horns", optionVO: "dic_yadina_st_017_alt"},
                {optionId: "balloons", cc: "Balloons", iconPosition: "center", sfx: "sc_007_XR103A_009_Chords_to the secret museum", voIndex: 18},
                {optionId: "worms", cc: "Worms", sfx: "sc_046_XR111B_094_DUn Dun Dun Music", voIndex: 19},
                {optionId: "popcorn", cc: "Popcorn", sfx: {"sc_007_XR103A_009_Chords_to the secret museum": 0, "sc_079_pop1": 0.8, "sc_080_pop2": 1, "sc_081_pop3": 1.2}, voIndex: 20},
            ],
            layout: CharlesDickensStoryLayout_scene4Chair,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Xavier, "re_xavier_006"),
            },
        },
        {
            sceneId: "belt",
            sfx: ["sc_070_XRMovie_695_Zoom Sqeak 1", "sc_056_XR113B_099_Flat Bass-y Horns"],
            cc: "And, Brad imagined he was holding a {option-belt!}",
            voIndex: 21,
            options: [
                {optionId: "banana", cc: "Banana", iconPosition: "center", voIndex: 22},
                {optionId: "tennisracket", cc: "Tennis Racket", iconPosition: "center", voIndex: 23},
                {optionId: "bowlingball", cc: "Bowling Ball", iconPosition: "center", voIndex: 24},
                {optionId: "lollipop", cc: "Lollipop", iconPosition: "center", voIndex: 25},
            ],
            layout: CharlesDickensStoryLayout_scene5Belt,
            injections: {
                afterFullVO: new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_008"),
            },
        },
        {
            sceneId: "end",
            cc: "So, Brad imagined he was relaxing in {option-end!}",
            voIndex: 26,
            options: [
                {optionId: "home", cc: "His Bedroom", icon: "dic-bed-buttonimg", sfx: "sc_076_hishome", voIndex: 27},
                {optionId: "circus", cc: "The Circus", iconPosition: "center", sfx: "sc_030_xr111B_080_Circus BG Music", voIndex: 28},
                {optionId: "museum", cc: "The Museum", iconPosition: "center", sfx: "sc_076_hishome", voIndex: 29},
                {optionId: "butterfly", cc: "The Butterfly Conservatory", iconPosition: "center", sfx: "sc_075_bestfriends", voIndex: 30},
            ],
            layout: CharlesDickensStoryLayout_scene6End,
            injections: {
                afterFullVO: new SceneInjectionChain(
                    new SceneInjectionCharacterReaction(CharacterType.Brad, "re_brad_004", true),
                    new SceneInjectionCharacterReaction(CharacterType.Yadina, "dic_yadina_st_031"),
                ),
            },
        },
    ],
};

export type CharlesDickensSceneId = "start" | "imagination" | "location" | "chair" | "belt" | "end";
export type CharlesDickensSlotId = CharlesDickensSceneId;
